export const deepEqual = (a: unknown, b: unknown): boolean => {
  if (a === b) return true;

  if (a === null || b === null) return false;

  if (typeof a !== typeof b) return false;

  if (Array.isArray(a) || Array.isArray(b)) {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;

    if (a.length !== b.length) return false;

    const usedIndexes: number[] = [];

    return a.every((aItem) => {
      const matchedIndex = b.findIndex((bItem, index) => {
        if (usedIndexes.includes(index)) return false;

        return deepEqual(aItem, bItem);
      });

      if (matchedIndex === -1) return false;

      usedIndexes.push(matchedIndex);
      return true;
    });
  }

  if (typeof a === "object" && typeof b === "object") {
    const aObject = a as Record<string, unknown>;
    const bObject = b as Record<string, unknown>;

    const aKeys = Object.keys(aObject);
    const bKeys = Object.keys(bObject);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every((key) => {
      if (!Object.prototype.hasOwnProperty.call(bObject, key)) {
        return false;
      }

      return deepEqual(aObject[key], bObject[key]);
    });
  }

  return false;
};
